import { IndustryModuleCode, IndustryProductID } from './../../../model/industry';
import { IndustriesPurchasedDetails } from './../../../model/IndustriesPurchasedDetails';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Account, AccountData } from 'src/app/model/account';
import { AccountRole } from 'src/app/model/account-role';
import { AccountService } from 'src/app/core/services/account.service';
import { AppSubscription, Mode, SubscriptionToken, SubscriptionProductRelease } from 'src/app/model/subscription';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { Component, OnInit, ViewChild, ChangeDetectorRef, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from 'src/app/core/services/login.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MiniStorageService } from 'src/app/core/services/mini-storage.service';
import { ModelService } from 'src/app/core/services/model.service';
import { ModuleInformation } from './../../../model/subscription';
import { RoleLevels, RoleNames, RolesWeight } from './../../../authentication/auth-helpers';
import { RolesSelectorConfig } from '../roles-selector/roles-selector.component';
import { RolesService } from 'src/app/core/services/roles.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';
import { UpdateRoles } from 'src/app/model/update-roles';
import { MatDrawer } from '@angular/material/sidenav';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { MatRadioChange } from '@angular/material/radio';
import { IndustryPurchasedInfo } from 'src/app/model/industry';
import { SubscriptionTokenMode } from 'src/app/model/configuration';
import { OperationResult, TbAuthService } from '@tb/auth';
import { LoadingService } from 'src/app/core/services/loading.service';
import { cloneDeep } from 'lodash';
import { SubscriptionWInstance } from '../subscription-management/subscription-management.component';
import { MiGenParameters } from 'src/app/model/MiGenParameters';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountHomeInfo } from 'src/app/model/account-home';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { CountryService } from 'src/app/core/services/country.service';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'ms-subscription-information',
    templateUrl: './subscription-information.component.html',
    styleUrls: ['./subscription-information.component.scss'],
})
export class SubscriptionInformationComponent implements OnInit, OnChanges {
    // #region events variables
    @ViewChild('matTabGroup') matTabGroup: MatTabGroup;
    @ViewChild('accountsTable') accountsTable: MatTable<any>;
    @Input() currentsubscriptionKey: string;
    @ViewChild('drawer') drawer: MatDrawer;
    @Input() isMoving: boolean;
    @Input() isSubNfs: boolean;
    @Output() subKey = new EventEmitter<string>();
    @Output() descriptionChanged = new EventEmitter<AppSubscription>();
    // #endregion events

    // #region booleans variables
    isFirstTime = true;
    existsMasterSubKey = false;
    isComponentInitialized = false;
    isChanged_roles = false;
    canShowAccountDetail = false;
    showFilterOptions = true;
    loading = true;
    seeNickName = false;
    subscriptionExist = false;
    isNotInternal = true;
    isDevOpsOrSysAdmin = false;
    havePermission = false;
    isEndUser = false;
    isUserAdmin = false;
    isLoggedAccountInternal = false;
    isApplicationAdmin = false;
    disableCheckbox = false;
    show = false;
    showAll = false;
    showChoices = true;
    isDevOpsOrHigher = false;
    showRoles = false;
    accountFound = true;
    dbOperationInProgress: boolean;
    readingData: boolean;
    deleteLinkToSubscriptionClicked: boolean;
    internalRoles: boolean;
    isActivated: boolean;
    owner: boolean;
    validEmail = false;
    public disableUploadButton = false;
    operationsExecutedSuccesfully = false;
    removeRowIsClicked = false;
    accountListLoading = false;
    dataProductInfoCached = false;
    dataCustomerDataCached = false;
    dataAssociatedAccountCached = false;
    dataMultiCompanyCached = false;
    showNoteInput = false;
    public isZucchettiDirettaUser = false;
    existsAuditing = false;
    existsSecurity = false;
    existsVisibility = false;
    existsCGM = false;
    showAdvancedSettings = false;
    showEmailSection = false;
    hideInfo = false;
    loadAdvancedSettingsTab = false;
    showVersionNotPresent = false;
    public smallScreen: boolean = false;
    // #endregion booleans

    // #region string variables
    authorizationStored: string;
    Roles: string = '';
    searchAccountText: string = '';
    previousAccount: string = '';
    choice: string = '';
    mode: string = '';
    moduleCode: string = '';
    userID: string = '';
    editionDescription: string = '';
    Accounts: string;
    contentAccounts: string;
    viewTitle: string;
    cartRowID: string;
    productID: string = '';
    languageOfTheUser: string;
    regionalSettingsOfTheUser: string;
    subtitle_1: string;
    subtitle_2: string;
    language: string;
    accountSelected: string;
    configuration: string;
    subscriptionSelected: string;
    instanceDescription: string;
    instanceMw: string;
    securityValueMW: string = '';
    // Serve Ancora ?
    advancedSettingsUpdateInfo: string;
    associatedAccountInfo: string;
    // #endregion string variables

    // #region other variables
    authorizationProperties: AuthorizationProperties;
    rolesActivated: [string, boolean];
    acconfly = new Account();
    accountDetail: AccountData;
    accountsT: AccountData[];
    model: AppSubscription;
    copyOfModel: AppSubscription;
    accountRoles: Array<AccountRole>;
    rolesResult: Array<AccountRole>;
    public cmsObj: CmsObject[];
    public industryCmsObj: CmsObject[];
    today = new Date();
    minDate = new Date();
    secondValue: Date;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    dataSourceAccounts: MatTableDataSource<AccountData>;
    dataSourceAccounts_2: MatTableDataSource<AccountHomeInfo>;
    prova: RolesSelectorConfig;
    subscription: SubscriptionWInstance;
    zucchetti_diretta_resellercodes: string[] = [];
    // unassociatedAccounts: string[] = [];
    subscriptionTokenInfo: SubscriptionToken;
    subTokenModeList: SubscriptionTokenMode[] = [];
    realRoles: UpdateRoles[] = [];
    listAccounts: AccountHomeInfo[] = [];
    count: number;
    advancedSettings: AdvancedSettings;
    copyOfAdvancedSettings: AdvancedSettings;
    //#endregion other variables
    isSubSlave: boolean = false;
    subscriptionOperation: Subscription;
    isNotModified_1 = true;
    isNotModified_2 = true;
    disableSaveButton = true;
    disableCancelButton = true;
    currentAccountLogged: Account;
    userAdmins: string[] = [];
    // --------------------------------------------------------------------------------
    constructor(
        private modelService: ModelService,
        private loginService: LoginService,
        private subscriptionService: SubscriptionService,
        private router: Router,
        private dialog: MatDialog,
        public workflow: WorkFlowService,
        private miniStorage: MiniStorageService,
        private rolesService: RolesService,
        private serviceUtilsService: ServiceUtilsService,
        private accountService: AccountService,
        public workFlow: WorkFlowService,
        private authService: TbAuthService,
        private cmsService: CmsService,
        private dateAdapter: DateAdapter<Date>,
        private variable: TranslatedVariables,
        public configurationService: ConfigurationService,
        private _formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        public loadingService: LoadingService,
        private notificationService: NotificationService,
        public storeRolesService: StoreRolesService,
        public countryService: CountryService,
        public cd: ChangeDetectorRef,
        private navigateService: NavigateService,
        private breakpointObserver: BreakpointObserver,
        private storeRoleService: StoreRolesService
    ) {
        this.dateAdapter.setLocale('it-IT');
        if (this.authService.isSessionStorage()) {
            this.languageOfTheUser = sessionStorage.getItem('M4_ui_culture');
            this.regionalSettingsOfTheUser = sessionStorage.getItem('M4_culture');
        } else {
            this.languageOfTheUser = localStorage.getItem('M4_ui_culture');
            this.regionalSettingsOfTheUser = localStorage.getItem('M4_culture');
        }
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.acconfly = new Account();
        this.model = new AppSubscription();
        this.copyOfModel = new AppSubscription();

        this.readingData = false;
        // this.tags = '';
        this.minDate.setDate(this.today.getDate() + 1);
        this.accountRoles = new Array<AccountRole>();
        this.internalRoles = this.rolesService.checkRolesMin(RolesWeight.INTERNAL, false);
        //roles
        this.rolesResult = new Array<AccountRole>();
        this.advancedSettings = new AdvancedSettings();
        this.copyOfAdvancedSettings = new AdvancedSettings();
    }

    async ngOnInit() {
        this.isEndUser = this.storeRolesService.isEndUser;

        this.activatedRoute.queryParams.subscribe((params) => {
            if (params.subscriptionSelected) {
                this.subscriptionSelected = atob(params.subscriptionSelected);
                this.subKey.emit(this.subscriptionSelected);
                this.currentsubscriptionKey = this.subscriptionSelected;
            }
        });

        this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
            this.smallScreen = result.matches;
        });

        //await this.amazonDSPService.getDefaultSettingsFromDB();

        this.loadInfo();
        await this.getInfoAccount();

        this.isComponentInitialized = true;
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    async getInfoAccount() {
        let opRes = await this.loginService.getAccountToPromiseBy(this.authorizationProperties.accountName);
        //Code 32 vuol dire che il token è scaduto
        if (opRes['Result']) {
            this.currentAccountLogged = opRes['Content'];
        } else {
            this.currentAccountLogged = undefined;
        }
    }
    async ngOnChanges() {
        if (this.isComponentInitialized) {
            // Remove query params when selected another subscription
            if (this.subscriptionSelected) {
                this.router.navigate([], {
                    queryParams: {
                        subscriptionSelected: null,
                    },
                    queryParamsHandling: 'merge',
                });
            }
            this.loadAdvancedSettingsTab = false;
            await this.loadInfo();
            this.notifyToUserDocumentList();
        }
    }

    ngAfterContentChecked() {
        this.cd.detectChanges();
    }

    applyAccountSearch(event: any) {
        let filterValue: string;
        filterValue = (event.target as HTMLInputElement).value;
        this.dataSourceAccounts.filterPredicate = function (data, filter: string): boolean {
            return data.AccountName.toLowerCase().includes(filter);
        };
        this.dataSourceAccounts.filter = filterValue.trim().toLowerCase();
        if (this.dataSourceAccounts.filteredData.length === 0) {
            this.accountFound = false;
            this.showFilterOptions = false;
            this.closeDrawer();
        } else {
            this.accountFound = true;
            this.showFilterOptions = true;
        }
    }

    // --------------------------------------------------------------------------
    copyText(inputElement) {
        inputElement.select();
        document.execCommand('copy');
    }

    // --------------------------------------------------------------------------
    submitSubscription() {
        if (this.model === undefined || this.model.SubscriptionKey === undefined) {
            this.workFlow.showMessage(this.variable.warningTitle, this.variable.dialogSubTitle_8);
            return;
        }
        this.subscriptionOperation = this.subscriptionService.saveSubscription(this.model).subscribe(
            (subscriptionResult) => {
                if (!subscriptionResult.Result) {
                    this.workFlow.showSnackBar(this.variable.operationFailed, subscriptionResult.Message);
                    return;
                }
                this.copyOfModel = new AppSubscription();
                this.copyOfModel.assign(this.model);
                this.descriptionChanged.emit(this.model);
                this.disableSaveButton = true;
                this.isNotModified_1 = true;
                this.isNotModified_2 = true;
                this.workFlow.showSnackBar(this.variable.operationSucceeded);
            },
            (err) => {
                this.workFlow.showMessage(this.variable.errorTitle, err.message);
            }
        );
    }
    // --------------------------------------------------------------------------
    async loadAssociatedAccounts() {
        if (this.model.SubscriptionKey === undefined || this.model.SubscriptionKey == null || this.model.SubscriptionKey.length === 0) {
            return;
        }
        await this.getAccountsAndRoles();
    }
    public async redirectToSubscriptionManagementPage() {
        if (!this.productID || this.productID.length == 0) {
            this.havePermission = false;
            return;
        } else {
            if (this.subscription.Mode == 1) {
                //rnfs
                this.countryService.setCountry(this.subscriptionTokenInfo.country);
            }
            await this.getSubscriptionDetails();

            this.navigateService.redirectToSubscriptionManagement(this.productID, this.subscription.Mode, this.model.SubscriptionKey);
        }
    }

    async getTabsReady() {
        this.havePermission = false;
        this.readingData = true;
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        //this.cartRowID = '';
        this.productID = '';

        let opRes = await this.subscriptionService.getSubscriptionsToPromise(
            this.authorizationProperties.accountName,
            this.currentsubscriptionKey
        );
        if (!opRes['Result']) {
            const message: string = opRes['Message'];
            this.workFlow.showMessage(
                this.variable.warningTitle,
                `${this.variable.dialogSubTitle_10}${this.currentsubscriptionKey}:${message}`
            );
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            this.readingData = false;
            this.navigateTo();

            return;
        }

        let resultSWI = await this.subscriptionService.getSubscriptionsWithInstanceKeyToPromise(
            this.authorizationProperties.accountName,
            this.currentsubscriptionKey
        );

        if (!resultSWI['Result']) {
            const message: string = resultSWI['Message'];
            this.workFlow.showMessage(this.variable.warningTitle, message);
            this.readingData = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            //old, da controllare
            return;
        }

        this.subscription = resultSWI['Content'].filter((x: SubscriptionWInstance) => x.SubscriptionKey === this.currentsubscriptionKey)[0];
        this.productID = this.subscription.InstanceOrigin;
        this.instanceDescription = `${this.subscription.InstanceKey} ${this.subscription.InstanceDescription}`;
        if (!this.subscription.IsEditable && !this.isDevOpsOrSysAdmin) {
            this.readingData = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            return;
        }

        this.subscriptionExist = true;
        const subscriptions: AppSubscription[] = opRes['Content'];
        this.subscriptionTokenInfo = subscriptions
            .filter((x) => x.SubscriptionKey === this.currentsubscriptionKey)
            .map((x) => x.SubscriptionToken)[0];
        this.getCmsObjForEdition(this.subscriptionTokenInfo.edition.toLowerCase());
        // this.getDBList();
        this.getSubscriptionTokeModeList();

        if (subscriptions === undefined || subscriptions.length === 0) {
            this.workFlow.showMessage(
                this.variable.warningTitle,
                `${this.variable.dialogSubTitle_10}${this.currentsubscriptionKey}:${opRes['Content']}`
            );
            this.readingData = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            return;
        }

        this.model = Object.assign(subscriptions[0]);
        this.copyOfModel = cloneDeep(subscriptions[0]);

        // this.copyOfModel.assign(subscriptions[0]);
        let moduleInformation: ModuleInformation[] = this.model.SubscriptionToken?.modules?.module;
        if (moduleInformation == null || moduleInformation == undefined) {
            this.workFlow.showMessage(
                this.variable.errorTitle,
                `The subscription token for ${this.model.SubscriptionKey} is empty or null`
            );
            this.readingData = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            return;
        }
        let isNewVersion = moduleInformation?.some((x) => x.fragment != null);
        this.existsMasterSubKey =
            this.model.MasterSubscriptionKey !== '' &&
            this.model.MasterSubscriptionKey !== undefined &&
            this.model.MasterSubscriptionKey !== null;
        this.existsAuditing = isNewVersion
            ? moduleInformation.some((x) => x.fragment.toLowerCase() === 'auditing')
            : moduleInformation.some((x) => x.name.toLowerCase() === 'extensions.tbauditing');
        this.existsSecurity = isNewVersion ? moduleInformation.some((x) => x.fragment.toLowerCase() === 'security') : false;
        this.existsVisibility = isNewVersion ? moduleInformation.some((x) => x.fragment.toLowerCase() === 'visibility') : false;
        this.existsCGM = isNewVersion ? moduleInformation.some((x) => x.fragment.toLowerCase() === 'cgm') : false;
        this.viewTitle = this.model.SubscriptionKey + ' ' + this.model.Description;
        //recupero il flusso

        if ((!this.productID || this.productID.length == 0) && this.existsMasterSubKey) this.productID = this.subscription.InstanceOrigin;

        await this.loadAssociatedAccounts();
        this.loading = false;
        this.loadingService.setLoading(this.loading);
        // metto nel ministorage le informazioni del model della subscription
        // da propagare nel database-orchestrator
        this.miniStorage.set(this.model.SubscriptionKey, this.model);
        this.readingData = true;
    }

    async getZucchettiDirettaResellerCodes() {
        let opRes: OperationResult = await this.serviceUtilsService.getStoreParameterValue('zucchetti_diretta_resellercodes');
        let content = new MiGenParameters();
        content = opRes.Content as MiGenParameters;
        this.zucchetti_diretta_resellercodes = content.Value.split(';');
    }

    async loadInfo() {
        if (this.currentsubscriptionKey === undefined || this.currentsubscriptionKey === '') {
            //old, da controllare
            return;
        }

        this.accountRoles = this.authorizationProperties.roles as AccountRole[];
        if (this.accountRoles.length === 0) {
            return;
        }

        this.isDevOpsOrSysAdmin = this.accountRoles.some((r) => r.Weight === RolesWeight.DEVOPS || r.Weight === RolesWeight.SYSADMIN);

        this.isUserAdmin = this.accountRoles.some(
            (r) =>
                r.Weight === RolesWeight.USERADMIN && r.EntityKey === this.currentsubscriptionKey && r.RoleLevel === RoleLevels.Subscription
        );

        this.isLoggedAccountInternal = this.accountRoles.some((r) => r.RoleName === RoleNames.Internal);

        this.isApplicationAdmin = this.accountRoles.some(
            (r) =>
                r.Weight === RolesWeight.USERADMIN && r.EntityKey === this.currentsubscriptionKey && r.RoleLevel === RoleLevels.Subscription
        );

        this.firstFormGroup = this._formBuilder.group({
            firstValue: ['', [Validators.required, Validators.maxLength(127)]],
        });
        this.secondFormGroup = this._formBuilder.group({
            emailValue: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
            verifyEmailValue: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
            fullNameValue: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(127)]],
            accountNameValue: [
                { value: this.firstFormGroup.controls['firstValue'].value, disabled: true },
                [Validators.required, Validators.maxLength(127)],
            ],
        });

        this.isOnlyInternal(this.accountRoles);
        await this.getTabsReady();
        this.getVersionMagoBySubKey();
        await this.getCmsObj();
        this.isComponentInitialized = true;
        this.matTabGroup.selectedIndex = 0;
    }

    viewPdf(num: number) {}

    isOnlyInternal(accountRoles: AccountRole[]) {
        if (accountRoles.some((x) => (x.EntityKey === this.currentsubscriptionKey || x.EntityKey === RoleLevels.All) && x.Weight === 8)) {
            this.isNotInternal = false;
        }
    }

    //-----------------------------------------------------------------------------
    async createAccountOrJustAssociate() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        this.acconfly.ParentAccount = this.authorizationProperties.accountName;
        this.acconfly.AuthenticationProvider = 'gwamonfly';
        if (!this.acconfly.Language) {
            this.acconfly.Language = this.languageOfTheUser;
            if (!this.acconfly.Language) {
                this.setDataForTheUser('Language');
            }
        }
        if (!this.acconfly.RegionalSettings) {
            this.acconfly.RegionalSettings = this.regionalSettingsOfTheUser;
            if (!this.acconfly.RegionalSettings) {
                this.setDataForTheUser('RegionalSettings');
            }
        }
        let userAsked4Create = this.choice === 'a';
        if (this.choice === 'c') {
            this.count = 0;
            await this.associateMultipleAccounts();
        } else {
            // creo account al volo coi dati minimali e della form
            let expirationDate: Date = this.secondValue;
            this.acconfly.AccountName = this.firstFormGroup.controls['firstValue'].value.replace(/\s/g, '');
            this.acconfly.Email = this.secondFormGroup.controls['emailValue'].value.trim();
            this.acconfly.FullName = this.secondFormGroup.controls['fullNameValue'].value.trim();
            await this.associateAccount(this.acconfly, expirationDate, userAsked4Create);
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    setDataForTheUser(word: string) {
        if (word === 'Language') {
            if (this.workFlow.languageIsItalian()) {
                this.acconfly.Language = 'it-IT';
            } else {
                this.acconfly.Language = 'en';
            }
            return;
        }
        if (word === 'RegionalSettings') {
            if (this.workFlow.languageIsItalian()) {
                this.acconfly.RegionalSettings = 'it-IT';
            } else {
                this.acconfly.RegionalSettings = 'en';
            }
            return;
        }
    }

    navigateTo() {
        this.router.navigate(['/mydashboard']);
    }

    setHowManyUserAdmin(element: AccountData[]): boolean {
        let roles;
        let count = 0;
        for (let i = 0; i < element.length; i++) {
            roles = element.map((x) => x.Roles.split(', '))[i];
            if (roles.some((x) => x === RoleNames.User_admin)) {
                let index = this.userAdmins.indexOf(element[i].AccountName);
                if (index == -1) this.userAdmins.push(element[i].AccountName);
                count++;
            }
        }
        if (count === 1) {
            this.disableCheckbox = true;
            return;
        }
        this.disableCheckbox = false;
        return;
    }

    eDateValueChange2(selectedValue: any) {
        if (!selectedValue._selected) {
            return;
        }
        this.secondValue = this.setDate(selectedValue._selected);
    }

    setDate(value: Date) {
        let d = new Date();
        let h = d.getHours();
        let m = d.getMinutes();
        let s = d.getSeconds();
        value.setHours(h);
        value.setMinutes(m);
        value.setSeconds(s);

        return value;
    }

    associationHasExpired(associationHasExpired: boolean) {
        return associationHasExpired;
    }

    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'emailvalidation');
        this.subtitle_1 = this.cmsObj.find((x) => x.ContentName == 'emailvalidation.subtitle_1').ContentTranslation;
        this.subtitle_2 = this.cmsObj.find((x) => x.ContentName == 'emailvalidation.subtitle_2').ContentTranslation;
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'agreementSection');
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'store');
        this.advancedSettingsUpdateInfo = this.cmsObj.find((x) => x.ContentName == 'store.advancedSettingsUpdateInfo').ContentTranslation;
        this.associatedAccountInfo = this.cmsObj.find((x) => x.ContentName == 'store.associatedAccountInfo').ContentTranslation;
    }

    async getCmsObjForEdition(edition: string) {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        if (edition == null) return '';
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'editiondescription');
        this.editionDescription = this.cmsObj.find((x) => x.ContentName == `editiondescription.${edition}`).ContentTranslation;

        // this.partnerCodeEmpty = this.cmsObj.find((x) => x.ContentName == 'datifatturazione.partnerCodeEmpty').ContentTranslation;
    }

    showAccountDetail(account: AccountData) {
        this.accountDetail = account;
        let selectedRoles = this.accountsT
            .filter((x) => x.AccountName === this.accountDetail.AccountName)
            .map((x) => x.Roles.split(','))[0];
        this.prova = {
            Roles: selectedRoles.map((x) => ({
                roleName: x,
                roleLevel: RoleLevels.Subscription,
                selected: true,
                accountSelected: this.accountDetail.AccountName,
                subscription: this.model.SubscriptionKey,
                parentAccountName: this.authorizationProperties.accountName,
                disableCheckbox: this.disableCheckbox,
                needsLevelAll: false,
            })),
        };
        this.updateSectionRoles();
    }

    async setAccountName(row: AccountData) {
        if (!this.removeRowIsClicked) {
            await this.setRolesTabsVisibility(row);
            this.canShowAccountDetail = true;
            this.drawer.open();
        }
    }

    async setRolesTabsVisibility(row: AccountData) {
        this.isZucchettiDirettaUser = this.storeRoleService.isZucchettiAccount;
        let amIaCASUSer =
            this.currentAccountLogged && this.currentAccountLogged.CASUser ? this.currentAccountLogged.CASUser.length > 0 : false;
        this.accountDetail = row;
        let isSubscriptionRtm = this.model.SubscriptionToken.mode === Mode.rtm;
        if (this.isLoggedAccountInternal && (this.isUserAdmin || this.isDevOpsOrSysAdmin) && !isSubscriptionRtm) {
            this.accountDetail.ShowAdministrativeRoles = true;
            this.accountDetail.ShowApplicationeRoles = true;
        } else {
            if ((amIaCASUSer || this.isZucchettiDirettaUser) && (this.isUserAdmin || this.isDevOpsOrSysAdmin)) {
                this.accountDetail.ShowAdministrativeRoles = this.accountDetail.CasUser && this.accountDetail.CasUser.length > 0; // è un CAS account
                this.accountDetail.ShowApplicationeRoles = !this.accountDetail.CasUser || this.accountDetail.CasUser.length == 0; //non è un CAS account
            } else {
                this.accountDetail.ShowAdministrativeRoles = false;
                this.accountDetail.ShowApplicationeRoles = false;
            }
        }
    }

    closeDrawer() {
        this.accountsT.filter((x) => x.AccountName === this.previousAccount).map((x) => (x.IsClicked = false));
        this.canShowAccountDetail = false;
        this.accountDetail = new AccountData();
        this.showChoices = true;
        this.choice = '';
        if (this.drawer) this.drawer.close();
    }

    changeBackground(accountName: any) {
        if (!this.removeRowIsClicked) {
            if (!this.isFirstTime) {
                this.accountsT.filter((x) => x.AccountName === this.previousAccount).map((x) => (x.IsClicked = false));
            }
            this.isFirstTime = false;
            this.accountsT.filter((x) => x.AccountName === accountName).map((x) => (x.IsClicked = true));
            this.previousAccount = this.accountsT.filter((x) => x.AccountName === accountName)[0].AccountName;
        }
    }

    removeRow(accountName: string) {
        this.removeRowIsClicked = true;
        this.closeDrawer();
        let dlgAsk;
        dlgAsk = this.dialog.open(YesNoDialogComponent, {
            data: {
                Title: this.variable.dialogTitle_5,
                Message: `${this.variable.dialogSubTitle_5_first}${accountName}${this.variable.dialogSubTitle_5_last}${this.currentsubscriptionKey} ?`,
                Result: true,
                ShowDisableMe: false,
            },
        });

        dlgAsk.afterClosed().subscribe((resAskDlg) => {
            this.removeRowIsClicked = false;
            if (!resAskDlg) {
                return;
            } else if (resAskDlg.Result) {
                this.deleteAssociation(accountName);
            }
        });
    }

    deleteAssociation(accountName: string) {
        const deleteOperation = this.modelService.deleteAccountSubscriptionAssociation(accountName, this.currentsubscriptionKey).subscribe(
            (delResult) => {
                if (!delResult.Result) {
                    alert(delResult.Message + ' (Error code:' + delResult.Code + ')');
                    deleteOperation.unsubscribe();
                    return;
                }
                deleteOperation.unsubscribe();

                // se sono riuscita a cancellare l'associazione rimuovo la riga nella griglia attivando un evento che chiamerà il componente padre

                this.accountsT = this.accountsT.filter((ad) => ad.AccountName !== accountName);
                this.dataSourceAccounts = new MatTableDataSource<AccountData>(this.accountsT);
                this.userAdmins = [];
                this.setHowManyUserAdmin(this.dataSourceAccounts.filteredData);
                this.closeDrawer();
            },
            (err: HttpErrorResponse) => {
                // this.saving = false;
                alert(err.message);
                deleteOperation.unsubscribe();
            }
        );
    }

    async getSubscriptionTokeModeList() {
        this.mode = '';
        let data: SubscriptionTokenMode[] = await this.configurationService.getAvailableSubscriptionTokenMode(
            false,
            this.authorizationProperties.accountName
        );
        if (data === null || data === undefined) {
            this.workFlow.showMessage(this.variable.messageTitle_1, this.variable.messageSubTitle_1);
            return;
        }

        this.subTokenModeList = data;
        if (this.subTokenModeList.length == 0) {
            this.workFlow.showMessage(this.variable.popupTitle, this.variable.messageSubTitle_2);
        }
        let result = this.subTokenModeList.filter((x) => x.Value === this.subscriptionTokenInfo.mode.toString()).map((x) => x.Name)[0];
        if (result && result != 'rtm') {
            this.mode = result;
        }
        this.industryCmsObj = await this.configurationService.getAllIndustriesNamesList(this.workFlow.getLanguageForCms());
        let moduleCodes: string[] = this.subscriptionTokenInfo?.industryCode.split('-');
        let industryCode = moduleCodes.length > 1 ? moduleCodes[1] : moduleCodes[0];
        let correctModuleCodeContentName =
            this.productID.length > 0 && this.productID === IndustryProductID.MC && industryCode == IndustryModuleCode.SERD
                ? industryCode + '_MC'
                : industryCode;
        //per MC il modulo SERD è stato inserito come SERD_MC per disambiguarlo da MW
        let translatedName = this.industryCmsObj.find((x) => x.ContentName === correctModuleCodeContentName).ContentTranslation;
        this.configuration = `${translatedName} ${this.editionDescription} ${this.mode}`;
    }

    showAssociateAccount() {
        this.accountsT.filter((x) => x.AccountName === this.previousAccount).map((x) => (x.IsClicked = false));
        this.canShowAccountDetail = false;
        this.drawer.open();
    }

    async getAccountHomeInfo() {
        let opRes = await this.modelService.getAccountHomeInfoToPromise(this.authorizationProperties.accountName);
        if (!opRes.Result || opRes['Content'].length === 0) {
            this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
            return;
        }
        let allUser: AccountHomeInfo[] = opRes['Content'].filter(
            (x: AccountHomeInfo) =>
                x.AccountName !== 'root.cloud@microarea.it' && x.AccountName !== this.authorizationProperties.accountName && x.IsEditable
        );
        let associatedAccount = this.accountsT.filter(
            (x) => x.AccountName !== 'root.cloud@microarea.it' && x.AccountName !== this.authorizationProperties.accountName
        );
        let unassociatedAccounts = [];
        this.sortArrayByAccountName(allUser);
        this.sortArrayByAccountName(associatedAccount);
        let clone = cloneDeep(allUser);
        if (allUser.length !== associatedAccount.length) {
            for (let i = 0; i < allUser.length; i++) {
                for (let j = 0; j < associatedAccount.length; j++) {
                    if (allUser[i].AccountName === associatedAccount[j].AccountName) {
                        const index = clone.findIndex((item) => item.AccountName === allUser[i].AccountName);
                        if (index !== -1) {
                            clone.splice(index, 1);
                        }
                    }
                }
            }
            unassociatedAccounts = clone;
        }
        this.dataSourceAccounts_2 = new MatTableDataSource<AccountHomeInfo>(unassociatedAccounts);
    }

    sortArrayByAccountName(array: Array<any>) {
        array.sort((a, b) => {
            const nameA = a.AccountName.toUpperCase();
            const nameB = b.AccountName.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });
    }

    getErrorMessage() {
        return this.firstFormGroup.controls['firstValue'].hasError('required')
            ? this.variable.commonsEmpty
            : this.firstFormGroup.controls['firstValue'].hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.secondFormGroup.controls['emailValue'].hasError('required')
            ? this.variable.commonsEmpty
            : this.secondFormGroup.controls['emailValue'].hasError('email')
            ? this.variable.commonsEmailNotValid
            : this.secondFormGroup.controls['emailValue'].hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.secondFormGroup.controls['verifyEmailValue'].hasError('required')
            ? this.variable.commonsEmpty
            : this.secondFormGroup.controls['verifyEmailValue'].hasError('email')
            ? this.variable.commonsEmailNotValid
            : this.secondFormGroup.controls['verifyEmailValue'].hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.secondFormGroup.controls['fullNameValue'].hasError('required')
            ? this.variable.commonsEmpty
            : this.secondFormGroup.controls['fullNameValue'].hasError('maxlength')
            ? this.variable.commonsMaxLength
            : this.secondFormGroup.controls['fullNameValue'].hasError('minlength')
            ? this.variable.commonsMinLength
            : '';
    }

    async showChoice(event: MatRadioChange) {
        this.choice = event.value;
        this.showChoices = false;
        if (event.value === 'a') {
            this.showAll = true;
        } else {
            this.showAll = false;
        }
        if (event.value === 'c') {
            this.dataSourceAccounts_2 = new MatTableDataSource<AccountHomeInfo>();
            this.accountListLoading = true;
            await this.getAccountHomeInfo();
            this.accountListLoading = false;
        }
    }

    backFromDrawer() {
        this.showChoices = true;
        this.choice = '';
        this.firstFormGroup = this._formBuilder.group({
            firstValue: ['', [Validators.required, Validators.maxLength(127)]],
        });
        this.secondFormGroup = this._formBuilder.group({
            emailValue: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
            verifyEmailValue: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
            fullNameValue: ['', [Validators.required, Validators.maxLength(127)]],
        });
        this.secondValue = null;
    }

    cancel() {
        this.model = new AppSubscription();
        this.model.assign(this.copyOfModel);
    }

    isInvalid1() {
        if (
            this.firstFormGroup.controls['firstValue'].invalid ||
            this.secondFormGroup.controls['emailValue'].invalid ||
            this.secondFormGroup.controls['fullNameValue'].invalid ||
            this.secondFormGroup.controls['verifyEmailValue'].invalid ||
            this.secondFormGroup.controls['emailValue'].value !== this.secondFormGroup.controls['verifyEmailValue'].value
        ) {
            return true;
        }
        return false;
    }

    isInvalid2() {
        return this.firstFormGroup.controls['firstValue'].invalid;
    }

    async getSubscriptionDetails() {
        let opResult = await this.modelService.getIndustryPurchasedDetails(
            this.authorizationProperties.accountName,
            this.model.SubscriptionKey
        );
        if (!opResult.Result) {
            return;
        }
        let industryPurchasedDetails: IndustriesPurchasedDetails = opResult.Content as IndustriesPurchasedDetails;
        if (industryPurchasedDetails.IndustryPurchased && industryPurchasedDetails.IndustryPurchased.length !== 0) {
            let industryPurchased: IndustryPurchasedInfo = JSON.parse(industryPurchasedDetails.IndustryPurchased) as IndustryPurchasedInfo;
            let s = industryPurchased.ModuleCode.split('-');
            this.moduleCode = s.length > 1 ? s[1] : s[0];
        }
        if (industryPurchasedDetails.UserID && industryPurchasedDetails.UserID.length !== 0) {
            this.userID =
                !industryPurchasedDetails.UserID || industryPurchasedDetails.UserID.length == 0 ? '' : industryPurchasedDetails.UserID;
            this.notifyToUserDocumentList();
        }
        return industryPurchasedDetails;
    }

    async doSomething(something: any) {
        await this.updateTable(something.value);
        if (this.accountsTable !== undefined) this.accountsTable.renderRows();
    }

    async updateTable(selected) {
        let opRes = await this.modelService.getAccountsAssociatedToPromiseTo(
            this.authorizationProperties.accountName,
            this.model.SubscriptionKey,
            'SUBSCRIPTION'
        );

        if (!opRes['Result']) {
            this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
            this.readingData = false;
            this.accountFound = false;
            this.showFilterOptions = false;
            return;
        } else {
            let result = this.filterRoles(opRes['Content'], selected);
            switch (selected) {
                case 'CO-USER-ADMIN':
                case 'USER-ADMIN':
                case 'POWER-USER':
                case 'POWER-USER-SCHEDULER':
                case 'POWER-USER-REPORT':
                case 'SECURITY-ADMIN':
                case 'APPLICATION-ADMIN':
                    this.accountsT = result;
                    this.dataSourceAccounts = new MatTableDataSource<AccountData>(this.accountsT);
                    break;
                default:
                    this.accountsT = opRes['Content'];
                    this.dataSourceAccounts = new MatTableDataSource<AccountData>(this.accountsT);
                    break;
            }
            this.showFilterOptions = true;
            if (this.accountsT.length === 0) {
                this.accountFound = false;
                return;
            }
            this.accountsT.map((x) => (x.ArrayRoles = x.Roles.split(', ')));
            this.accountFound = true;
        }
    }

    onClickSubKey(subKey: string) {
        this.subKey.emit(subKey);
    }

    // #region roles
    async getAccountsAndRoles() {
        let opRes = await this.modelService.getAccountsAssociatedToPromiseTo(
            this.authorizationProperties.accountName,
            this.model.SubscriptionKey,
            'SUBSCRIPTION'
        );

        if (!opRes['Result']) {
            this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
            this.readingData = false;
            this.accountFound = false;
            this.showFilterOptions = false;
            return;
        }

        this.accountsT = opRes['Content'].filter((x) => x.AccountName !== 'root.cloud@microarea.it' || x.AccountName !== 'testadmin');

        // this.showAccountDetail(this.accountsT[0]);
        for (let i: number = 0; i < this.accountsT.length; i++) {
            this.accountsT[i].ArrayRoles = this.accountsT[i].Roles.split(', ');
            // this.accountsT.
            let year = this.today.getFullYear();
            let day = this.today.getDate();
            let month = this.today.getMonth();
            var todayTimestamp = new Date(year, month - 1, day);
            let expirationDate = new Date(this.accountsT[i].ExpirationDate);
            let expirationYear = expirationDate.getFullYear();
            let expirationDay = expirationDate.getDate();
            let expirationMonth = expirationDate.getMonth();
            var expirationDayTimestamp = new Date(expirationYear, expirationMonth - 1, expirationDay);
            if (expirationYear >= 2121) {
                this.accountsT[i].willExpireIn100 = true;
            }
            // let yearsDiff = Math.abs(expirationYear - year);
            // if (yearsDiff >= 10) {
            //   this.accountsT[i].ExpirationDate = "NEVER";
            // }
            if (todayTimestamp.getTime() >= expirationDayTimestamp.getTime()) {
                this.accountsT[i].associationHasExpired = true;
            } else {
                this.accountsT[i].associationHasExpired = false;
            }
        }
        this.show = true;
        this.dataSourceAccounts = new MatTableDataSource<AccountData>(this.accountsT);
        this.userAdmins = [];
        this.setHowManyUserAdmin(this.dataSourceAccounts.filteredData);
        // if ((this.model.Status & EntityStatus.PrivacyMode) === EntityStatus.PrivacyMode) {
        //   // this.displayedColumnsAccounts = ['AccountName', 'NickName', 'Date', 'ExpirationDate', 'Roles', 'Actions'];
        //   this.checked = true;
        // } else {
        //   // this.displayedColumnsAccounts = ['AccountName', 'Date', 'ExpirationDate', 'Roles', 'Actions'];
        //   this.checked = false;
        // }
        this.cd.detectChanges();

        if (this.accountsT.length === 0) {
            return;
        }

        this.readingData = false;
    }

    filterRoles(listAccountAssociated: AccountData[], role) {
        let arraysOfRoles = listAccountAssociated.map((x) => x.Roles.split(', '));
        let filteredAccounts: AccountData[] = [];
        for (let i = 0; i < arraysOfRoles.length; i++) {
            if (arraysOfRoles[i].some((x) => x === role)) {
                filteredAccounts.push(listAccountAssociated[i]);
            }
        }
        return filteredAccounts;
    }

    setRoles(newRoles: UpdateRoles[]) {
        let roles = this.accountsT.filter((X) => X.AccountName === this.accountDetail.AccountName).map((x) => x.Roles.split(', '))[0];
        let rolesToRemove: string[] = newRoles.filter((x) => x.IsModified === true && x.Value === true).map((x) => x.RoleName);
        let rolesToAdd = newRoles.filter((x) => x.IsModified === true && x.Value === false).map((x) => x.RoleName);
        for (let i = 0; i < rolesToRemove.length; i++) {
            let index = roles.indexOf(rolesToRemove[i]);
            roles.splice(index, 1);
        }
        for (let i = 0; i < rolesToAdd.length; i++) {
            roles.push(rolesToAdd[i]);
        }
        //Roles
        this.accountsT.filter((X) => X.AccountName === this.accountDetail.AccountName).map((x) => (x.Roles = roles.join(', ')));
        //ArrayRoles
        this.accountsT.filter((X) => X.AccountName === this.accountDetail.AccountName).map((x) => (x.ArrayRoles = roles));
        this.dataSourceAccounts = new MatTableDataSource<AccountData>(this.accountsT);
        this.userAdmins = [];
        this.setHowManyUserAdmin(this.dataSourceAccounts.filteredData);
        this.closeDrawer();
    }

    updateSectionRoles() {
        this.realRoles = [];
        let subscription = this.prova.Roles[0].subscription;
        this.accountSelected = this.prova.Roles[0].accountSelected;

        this.owner = this.authorizationProperties.roles.some(
            (x) => x.EntityKey === subscription && x.RoleLevel === RoleLevels.Subscription && x.Weight === RolesWeight.USERADMIN
        );
        this.isDevOpsOrHigher = this.rolesService.checkRolesMin(RolesWeight.DEVOPS);
        this.rolesService
            .GetListRolesToAssociate(this.prova.Roles[0].parentAccountName, this.prova.Roles[0].roleLevel, subscription)
            .subscribe(
                (resultRoles) => {
                    this.accountRoles = resultRoles['Content'] as AccountRole[];
                    if (this.accountRoles.length === 0) {
                        return;
                    }
                    for (var j: number = 0; j < this.accountRoles.length; j++) {
                        let existRole = this.prova.Roles.some((k) => k.roleName.trim() === this.accountRoles[j].RoleName);
                        this.realRoles.push({
                            RoleName: this.accountRoles[j].RoleName,
                            Description: this.accountRoles[j].Description,
                            Value: existRole,
                            IsModified: false,
                            AccountName: this.authorizationProperties.accountName,
                            Weight: this.accountRoles[j].Weight,
                        });
                    }
                    this.showRoles = true;
                },
                (err) => {
                    this.workFlow.showMessage(this.variable.roles, err.message);
                }
            );
    }

    notifyToUserDocumentList() {
        this.notificationService.notifyOther(this.userID);
    }

    setuploadButtonDisabled(proxyNotAvailable: boolean) {
        this.disableUploadButton = proxyNotAvailable;
    }

    setListAccounts(event: AccountHomeInfo[]) {
        this.listAccounts = event;
    }

    async associateMultipleAccounts() {
        this.listAccounts.forEach(async (value, index, array) => {
            this.acconfly.AccountName = array[index].AccountName;
            await this.associateAccount(this.acconfly, array[index].ExpirationDateSubscription, false);
        });
    }

    associateAccount(account: Account, expirationDateSubscription: Date, userAsked4Create: boolean) {
        const callAPI = () => {
            return new Promise(async (resolve) => {
                await this.accountService
                    .CreateAccountOrJustAssociate(account, this.model.SubscriptionKey, expirationDateSubscription, userAsked4Create)
                    .subscribe(
                        async (opRes: OperationResult) => {
                            this.count++;
                            if (opRes === undefined || !opRes || !opRes.Result) {
                                this.workFlow.showMessage(this.variable.operationFailed, opRes?.Message);
                                this.loading = false;
                                this.loadingService.setLoading(this.loading);
                                return;
                            }
                            if (opRes.Result) {
                                this.operationsExecutedSuccesfully = true;
                                resolve('resolved');
                            } else {
                                this.operationsExecutedSuccesfully = false;
                                resolve('resolved');
                                return;
                            }
                        }, // serve questo codice ?
                        (err: HttpErrorResponse) => {
                            alert(err.message);
                        }
                    );
            })
                .then(async () => {
                    if (
                        (this.count && this.count === this.listAccounts.length && this.operationsExecutedSuccesfully) ||
                        (this.operationsExecutedSuccesfully && !this.count)
                    ) {
                        this.backFromDrawer();
                        this.closeDrawer();
                        await this.loadAssociatedAccounts();
                        this.workFlow.showSnackBar(this.variable.operationSucceeded, this.variable.successfully_completed);
                    } else if (!this.operationsExecutedSuccesfully) {
                        this.workFlow.showSnackBar(this.variable.failed, this.variable.operationFailed);
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.workFlow.showSnackBar(this.variable.failed, err.message);
                });
        };
        const asyncCall = async () => {
            const result = await callAPI();
        };
        asyncCall();
    }

    getVersionMagoBySubKey() {
        const getVersion = this.subscriptionService.getVersionBySubscriptionKey(this.currentsubscriptionKey).subscribe(
            (getVersionResult) => {
                if (getVersionResult === null || getVersionResult === undefined) {
                    this.showAdvancedSettings = false;
                    this.showEmailSection = false;
                    this.hideInfo = false;
                    // this.workFlow.showSnackBar(this.variable.warningTitle, 'no data');
                    getVersion.unsubscribe();
                    return;
                }
                if (getVersionResult.Result) {
                    let subVersion = SubscriptionProductRelease.create(getVersionResult.Content);
                    if (subVersion.Major > 0) {
                        if (this.subscription.InstanceOrigin === 'MW') {
                            this.showEmailSection = (subVersion.Major == 1 && subVersion.Minor >= 3) || subVersion.Major > 2 ? false : true;
                            this.hideInfo =
                                subVersion.Major >= 5 &&
                                this.model.SubscriptionToken.mode !== Mode.dvlp &&
                                this.model.SubscriptionToken.mode !== Mode.unknown
                                    ? true
                                    : false;
                        } else {
                            this.showEmailSection = (subVersion.Major == 2 && subVersion.Minor >= 3) || subVersion.Major > 2 ? false : true;
                            this.hideInfo = false;
                        }
                        this.showVersionNotPresent = false;
                        this.showAdvancedSettings = (subVersion.Major == 2 && subVersion.Minor >= 1) || subVersion.Major > 2 ? false : true;
                    } else {
                        this.showVersionNotPresent = true;
                        this.showAdvancedSettings = false;
                        this.showEmailSection = false;
                        this.hideInfo = false;
                    }
                } else {
                    this.showVersionNotPresent = false;
                    this.showAdvancedSettings = false;
                    this.showEmailSection = false;
                    this.hideInfo = false;
                    this.workFlow.showSnackBar(this.variable.warningTitle, getVersionResult.Message);
                }
                getVersion.unsubscribe();
            },
            (getVersionError: HttpErrorResponse) => {
                this.showAdvancedSettings = false;
                this.showEmailSection = false;
                this.hideInfo = false;
                this.workFlow.showSnackBar(this.variable.warningTitle, getVersionError.message);
                getVersion.unsubscribe();
            }
        );
    }

    async onSelectTab() {
        // Gestire qui tutti i caricamenti inerenti alle singole tab per un ottimizzazione migliore del codice
        // L'iter da seguire dovrebbe essere che se ci entra la prima volta nelle tab effettua le chiamate e poi se le tiene cachate finchè l'utente non esce proprio dalla pagina
        switch (this.matTabGroup.selectedIndex) {
            case 0:
                if (!this.dataProductInfoCached) {
                }
                break;
            case 1:
                if (!this.dataCustomerDataCached) {
                }
                break;
            case 2:
                if (!this.dataAssociatedAccountCached) {
                }
                break;
            case 3:
                this.loadAdvancedSettingsTab = true;
                break;
            case 4:
                if (!this.dataMultiCompanyCached) {
                }
                break;
        }
    }

    setDescription($event) {
        console.log($event);
        // this.descriptionChanged.emit(this.model);
    }
    public async resendMagoWebInformationMail() {
        let opResult = await this.subscriptionService.sendMagoWebEmail(this.currentsubscriptionKey);
        if (opResult.Result) {
            this.notificationService.success(this.variable.mailSent);
        } else {
            this.notificationService.warn(this.variable.mailNotSent);
        }
    }
}

// enum as [Flags] to set multiple status in MP_Subscriptions and MP_Instances
// ATTENTION! da tenere allineato con quello nel frontend della CloudConsole
// --------------------------------------------------------------------------------------------------------
export enum EntityStatus {
    None = 0,
    DBUnderMaintenance = 1 << 0, // 1
    Disabled = 1 << 1, // 2
    PrivacyMode = 1 << 2, // 4
    Canary = 1 << 4, // 8
    UpdateScheduled = 1 << 8, // 16
}

export class AdvancedSettings {
    CheckedVisibility: boolean;
    CheckedSecurity: boolean;
    CheckedCGM: boolean;
    CheckedAuditing: boolean;

    constructor() {
        this.CheckedVisibility = false;
        this.CheckedSecurity = false;
        this.CheckedCGM = false;
        this.CheckedAuditing = false;
    }

    assign(checkedVisibility: boolean, checkedSecurity: boolean, checkedCGM: boolean, checkedAuditing: boolean) {
        this.CheckedVisibility = checkedVisibility;
        this.CheckedSecurity = checkedSecurity;
        this.CheckedCGM = checkedCGM;
        this.CheckedAuditing = checkedAuditing;
    }
}
